<script>
import { authMethods } from "@/state/helpers";
import ValidationInput from "@/components/ValidationFormInputs/ValidationInput";

export default {
  components: { ValidationInput },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
    };
  },

  created() {
    document.body.classList.add("auth-body-bg");
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.authError = null;
      const { username, password } = this;
      if (username && password) {
        this.login({
          username,
          password,
          isAdmin: false,
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div
              class="authentication-page-content p-4 d-flex align-items-center min-vh-100"
            >
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <img
                              src="@/assets/images/logo-light.png"
                              height="40"
                              alt="logo"
                            />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">خوش اومدی!</h4>
                        <p class="text-muted">
                          از اینجا می تونی وارد حساب کاربری خودت بشی
                        </p>
                      </div>

                      <div class="p-2 mt-3">
                        <ValidationObserver
                          tag="div"
                          v-slot:="{ handleSubmit }"
                        >
                          <form
                            class="form-horizontal"
                            @submit.prevent="handleSubmit(tryToLogIn)"
                          >
                            <div class="col-12">
                              <validation-input
                                v-model="username"
                                type="text"
                                placeholder="نام کاربری، ایمیل یا تلفن همراه"
                                rules="required"
                                validation-field-name="نام کاربری، ایمیل یا تلفن همراه"
                                label="نام کاربری، ایمیل یا تلفن همراه"
                              ></validation-input>
                            </div>

                            <div class="col-12">
                              <validation-input
                                v-model="password"
                                type="password"
                                placeholder="رمز عبور"
                                rules="required|min:8"
                                validation-field-name="رمز عبور"
                                label="رمز عبور"
                              ></validation-input>
                            </div>

                            <div class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="customControlInline"
                              />
                              <label
                                class="custom-control-label"
                                for="customControlInline"
                                >منو یادت باشه</label
                              >
                            </div>

                            <div class="mt-4 text-center">
                              <button
                                class="btn btn-primary w-md waves-effect waves-light"
                                type="submit"
                              >
                                ورود
                              </button>
                            </div>

                            <div class="mt-4 text-center">
                              <router-link
                                tag="a"
                                to="/reset-password"
                                class="text-muted"
                              >
                                <i class="mdi mdi-lock mr-1"></i>رمز عبورت رو
                                فراموش کردی؟
                              </router-link>
                            </div>
                            <div class="mt-4 text-center">
                              <i class="mdi mdi-lock mr-1"></i>
                              حساب کاربری نداری؟
                              <router-link
                                tag="a"
                                to="/register"
                                class="text-primary"
                              >
                                ایجاد حساب کاربری
                              </router-link>
                            </div>
                          </form>
                        </ValidationObserver>
                      </div>

                      <div class="mt-3 text-center">
                        <p>
                          © 2021 ایجاد شده توسط
                          <a href="http://arp2.ir">اصحاب رسانه پویا</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
